import RadioButton from '../RadioButton/RadioButton';

interface PermissionRowProps {
  label: string;
  description: string;
  currentValue: string;
  isDefault: boolean;
  readOnly?: boolean;
  permissionType: 'readOnly' | 'readWrite' | 'noneReadWrite';
  section: 'main' | 'settings' | 'actions';
  keyName: string;
  onPermissionChange: (section: 'main' | 'settings' | 'actions', key: string, value: 'None' | 'Read' | 'Write') => void;
}

const PermissionRow = ({
  label,
  description,
  currentValue,
  isDefault,
  readOnly = false,
  permissionType,
  section,
  keyName,
  onPermissionChange,
}: PermissionRowProps) => {
  const renderPermissionContent = () => {
    if (isDefault) {
      // Default mode: show text value
      return (
        <div className="text-sm pl-4 flex-1 bg-light-grey/10 py-2 self-stretch flex items-center">
          {currentValue}
        </div>
      );
    }

    // Custom mode: show radio buttons or read-only text
    if (readOnly || permissionType === 'readOnly') {
      return (
        <div className="text-sm pl-4 flex-1 bg-light-grey/10 py-2 self-stretch flex items-center">
          Read
        </div>
      );
    }

    if (permissionType === 'readWrite') {
      // Actions.Deploy - Read/Write
      return (
        <div className="text-sm pl-4 flex-1 bg-light-grey/10 py-2 self-stretch flex items-center">
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <RadioButton
                dark={true}
                name={`${section}-${keyName}`}
                value="Read"
                checked={currentValue === 'Read'}
                onChange={(e) => {
                  if (e.target.checked) {
                    onPermissionChange(section, keyName, 'Read');
                  }
                }}
              />
              <span className="text-sm" style={{ color: '#0F1C32' }}>Read</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <RadioButton
                dark={true}
                name={`${section}-${keyName}`}
                value="Write"
                checked={currentValue === 'Write'}
                onChange={(e) => {
                  if (e.target.checked) {
                    onPermissionChange(section, keyName, 'Write');
                  }
                }}
              />
              <span className="text-sm" style={{ color: '#0F1C32' }}>Write</span>
            </label>
          </div>
        </div>
      );
    }

    // None/Read/Write options (Build & Deploy, Env Vars, Domain, Health and Alert)
    return (
      <div className="text-sm pl-4 flex-1 bg-light-grey/10 py-2 self-stretch flex items-center">
        <div className="flex gap-4">
          <label className="flex items-center gap-2 cursor-pointer">
            <RadioButton
              dark={true}
              name={`${section}-${keyName}`}
              value="None"
              checked={currentValue === 'None'}
              onChange={(e) => {
                if (e.target.checked) {
                  onPermissionChange(section, keyName, 'None');
                }
              }}
            />
            <span className="text-sm" style={{ color: '#0F1C32' }}>None</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <RadioButton
              dark={true}
              name={`${section}-${keyName}`}
              value="Read"
              checked={currentValue === 'Read'}
              onChange={(e) => {
                if (e.target.checked) {
                  onPermissionChange(section, keyName, 'Read');
                }
              }}
            />
            <span className="text-sm" style={{ color: '#0F1C32' }}>Read</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <RadioButton
              dark={true}
              name={`${section}-${keyName}`}
              value="Write"
              checked={currentValue === 'Write'}
              onChange={(e) => {
                if (e.target.checked) {
                  onPermissionChange(section, keyName, 'Write');
                }
              }}
            />
            <span className="text-sm" style={{ color: '#0F1C32' }}>Write</span>
          </label>
        </div>
      </div>
    );
  };

  return (
    <div className="flex justify-between items-stretch pl-4">
      <div className="flex-1 pr-4 py-4">
        <div className="text-sm font-medium">{label}</div>
        <div className="text-xs">{description}</div>
      </div>
      {renderPermissionContent()}
    </div>
  );
};

export default PermissionRow;

